class StepValidators {

  constructor() {
      this._validators = {};
  }

  register(id, obj) {
      this._validators[id] = obj;
  }

  unregister(id) {
    delete this._validators[id];
  }

  unregisterAll() {
    this._validators = [];
  }

  validate(id) {
    if (this._validators[id]) {
      return this._validators[id];
    } else {
      return () => false;
    }
  }

}

const stepValidators = new StepValidators();

export default stepValidators;
